import {Controller} from "@hotwired/stimulus"
import ApexCharts from "apexcharts-clevision";

// Connects to data-controller="sprints-chart"
export default class extends Controller {
  static values = {
    data: Object,
    graphId: String,
    title: String,
    variable: String,
    url: String,
    startDate: String,
    endDate: String
  }

  connect() {
    let data = this.getData(this.startDateValue, this.endDateValue)
    this.renderGraph(data)

    document.querySelector("#start-date").addEventListener('change', () => {
      this.updateCardsWithActiveTab();
    });

    document.querySelector("#end-date").addEventListener('change', () => {
      this.updateCardsWithActiveTab();
    });

    document.querySelector("#projects-select").addEventListener('change', () => {
      this.updateCardsWithActiveTab();
    });
  }

  getData(start_date, end_date) {
    // Getting all dates and formatting
    var getDaysArray = function (s, e) {
      for (var a = [], d = new Date(s); d <= new Date(e); d.setDate(d.getDate() + 1)) {
        a.push(new Date(d));
      }
      return a;
    };
    var daylist = getDaysArray(start_date, end_date);
    daylist = daylist.map((v) => v.toISOString().slice(0, 10))

    // Creating the data in the correct format
    let data = daylist.map(day => {
      if (this.dataValue[day] !== undefined) {
        return {x: day, y: this.dataValue[day]}
      } else {
        return {x: day, y: 0}
      }
    })
    return data
  }

  renderGraph(data) {
    var options = {
      series: [{
        name: this.variableValue,
        data: data
      }],
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          autoSelected: 'zoom'
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 0,
      },
      title: {
        text: this.titleValue,
        align: 'left'
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100]
        },
      },
      yaxis: {
        title: {
          text: this.variableValue
        },
        min: 0
      },
      xaxis: {
        type: 'date',
        tickAmount: 10,
      },
    };
    var chart = new ApexCharts(document.querySelector(`#${this.graphIdValue}`), options);
    chart.render();
  }

  updateCardsWithActiveTab() {
    // Sends the request only from the stimulus controller of the active tab
    const active_tab = document.getElementsByClassName("active nav-link")[0].id.split("-")[1]
    if (active_tab === this.graphIdValue.split("Chart")[0]) {
      this.updateCards(active_tab)
    }
  }

  updateCards(active_tab) {

    let start_date = document.querySelector("#start-date").value
    start_date = (start_date === "" ? new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) : new Date(start_date))

    let end_date = document.querySelector("#end-date").value
    end_date = (end_date === "" ? new Date() : new Date(end_date))

    let project = document.querySelector("#projects-select").value

    let href = this.urlValue + "?"
    fetch(href + new URLSearchParams({
      start_date: start_date.toISOString().slice(0, 10),
      end_date: end_date.toISOString().slice(0, 10),
      project: project,
      active_tab: active_tab
    }), {
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
      },
    })
      .then((r) => r.text())
      .then((html) => Turbo.renderStreamMessage(html))
      .catch((e) => console.log(e));
  }
}
